export const load = () => ({
	title: 'Heat Retention Window Solutions',
	h1: 'Block Cold Drafts & Retain Heat With Insulating Window Inserts',
	description:
		'Insulate your windows from cold drafts, retain heat in your home, and save on energy bills. ',
	showTitle: true,
});
